import { Id } from 'drf-react-by-schema';
import { FlocosProductionStatus } from 'src/constants';
import { ProcessingKey } from 'src/constants/ProcessingKey';

export enum TotalsMesocarpoProcessing {
  PROCESSED = 'total_processed',
  LOST = 'total_losses',
  LOTES_GRUPOS = 'lotes_grupos',
  AVERAGE_GRUPOS = 'average_grupos',
  PCTES_UM_QUARTO = 'total_pctes_um_quarto',
  PCTES_METADE = 'total_pctes_metade',
}

export const getTotalsMesocarpoProcessingLabel = ({
  key,
  unit,
}: {
  key: TotalsMesocarpoProcessing;
  unit?: boolean;
}) => {
  if (unit) {
    switch (key) {
      case TotalsMesocarpoProcessing.PROCESSED:
        return 'Kg';
      case TotalsMesocarpoProcessing.LOST:
        return 'Kg';
      case TotalsMesocarpoProcessing.LOTES_GRUPOS:
        return 'lotes';
      case TotalsMesocarpoProcessing.AVERAGE_GRUPOS:
        return 'Kg/Lote';
      case TotalsMesocarpoProcessing.PCTES_UM_QUARTO:
        return 'Unidades';
      case TotalsMesocarpoProcessing.PCTES_METADE:
        return 'Unidades';
    }
  }
  switch (key) {
    case TotalsMesocarpoProcessing.PROCESSED:
      return 'Total beneficiado';
    case TotalsMesocarpoProcessing.LOST:
      return 'Perdas e Resíduos';
    case TotalsMesocarpoProcessing.LOTES_GRUPOS:
      return 'Lotes dos grupos';
    case TotalsMesocarpoProcessing.AVERAGE_GRUPOS:
      return 'Produção média por grupo';
    case TotalsMesocarpoProcessing.PCTES_UM_QUARTO:
      return 'Pacotes de 250g';
    case TotalsMesocarpoProcessing.PCTES_METADE:
      return 'Pacotes de 500g';
  }
};

export type TotalsEntrepostoPerStatus = {
  [FlocosProductionStatus.IN_PRODUCTION]: number;
  [FlocosProductionStatus.READY_TO_REVIEW]: number;
  [FlocosProductionStatus.REVIEWED]: number;
  [FlocosProductionStatus.COMPLETE]: number;
  ready_to_review_lotes: Id[];
  reviewed_lotes: Id[];
};

export type HomeTotalsEntrepostoType = {
  [ProcessingKey.MESOCARPO]: Record<TotalsMesocarpoProcessing, number>;
  [ProcessingKey.FLOCOS]: TotalsEntrepostoPerStatus;
};
